import { render, staticRenderFns } from "./AudienceLogo.vue?vue&type=template&id=0a22f954&scoped=true"
import script from "./AudienceLogo.vue?vue&type=script&lang=js"
export * from "./AudienceLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22f954",
  null
  
)

export default component.exports